export default __webpack_public_path__ + "static/media/laptop.aa979cfb.svg";